var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.706 10.4703C14.6871 8.57022 16.2554 7.6589 16.3256 7.61286C15.4441 6.3241 14.0709 6.14726 13.5822 6.12714C12.4145 6.00854 11.3025 6.81497 10.7101 6.81497C10.119 6.81497 9.20368 6.14452 8.23535 6.16159C6.96153 6.1805 5.7874 6.90247 5.13189 8.04276C3.80898 10.3377 4.79346 13.7387 6.08253 15.6013C6.71274 16.5117 7.46429 17.5361 8.4503 17.4986C9.40063 17.4611 9.75918 16.8839 10.908 16.8839C12.0568 16.8839 12.3794 17.4986 13.3846 17.4794C14.4066 17.4608 15.0545 16.5516 15.6795 15.6375C16.403 14.5799 16.7009 13.5558 16.7186 13.5039C16.6963 13.4936 14.7264 12.739 14.706 10.4703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8179 4.8949C13.3408 4.26012 13.6951 3.37808 13.5987 2.5C12.8441 2.53049 11.9307 3.00154 11.3889 3.63571C10.9035 4.19853 10.4791 5.0946 10.5929 5.95683C11.4346 6.02207 12.2932 5.52846 12.8179 4.8949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3174a46505550b97d1987d6c4a9b6901.svg";
export { ForwardRef as ReactComponent };